import React, { Fragment, useState } from 'react'
import { Link } from 'react-router-dom'
import EditBtn from '../buttons/EditBtn'
import SendBtn from '../buttons/SendBtn'
import DeleteBtn from '../buttons/DeleteBtn'
import { routes } from '../../constantes/routes'
import { dateToDayMonthYear } from '../../utils/date'
import '../../assests/styles/presentation/send-status.scss'
import NullMssg from '../common/NullMssg'
import { mssgs } from '../../constantes/mssgs'
import _ from 'lodash'
import OpenBtn from '../buttons/OpenBtn'
import { useHistory } from 'react-router-dom'
import TasksModal from '../management/tasks/TasksModal'
import { tasksApi } from '../../api/tasksApi'
import { swalAlertError } from '../../utils/swalAlert'

const PresentationListTable = ({
  items,
  handleRemovePresentation,
  handleSendPresentationToContact,
  isDisabled,
  gotoEdit,
  canEditDeleteSendPresentation,
  // Props para el modal de tasks
  phases = [],
  contacts = [],
  events = [],
  businessunits = [],
  hospitals = [],
  specialties = [],
}) => {
  const history = useHistory()

  // Estado para el modal de task view
  const [taskModalIsOpen, setTaskModalIsOpen] = useState(false)
  const [selectedTask, setSelectedTask] = useState({
    id_Crm: '',
    id_Usuario: '',
    id_Contacto: '',
    id_TipoFase: '',
    id_TipoAsunto: '',
    asunto: '',
    fecha: '',
    descripcion: '',
    isVerCaledario: false,
    id_Evento: '',
    id_NegocioUnidades: [],
    hospitales: '',
    especialidades: '',
  })
  const [isLoadingTask, setIsLoadingTask] = useState(false)

  const isActive = (value) => {
    const colorText = value ? 'products__text' : 'products__text-readOnly'
    return colorText
  }

  const presentationStatus = (status) => {
    let _class = ''
    let _label = ''
    if(status == 0) _class = 'pres-status-default'
    if(status == 1) _class = 'pres-status-sent'
    if(status == 2) _class = 'pres-status-viewed'
    if(status == 3) _class = 'pres-status-downloaded'
    if(status == 0) _label = 'Creada'
    if(status == 1) _label = 'Enviada'
    if(status == 2) _label = 'Vista'
    if(status == 3) _label = 'Descargada'
    return (
      <div>
        <div className={_class}></div>
        <span style={{ fontSize: '80%'}}>{_label}</span>
      </div>
    );
  }

  const toViewLeads = async (leadId) => {
    if (!leadId) return

    setIsLoadingTask(true)
    try {
      // Cargar los datos del task desde la API
      const response = await tasksApi.getTasksById(leadId)
      const taskData = response.data

      console.log(response);

      // Formatear fecha para el input
      const formatDateForInput = (dateString) => {
        if (!dateString) return ''
        const date = new Date(dateString)
        return date.toISOString().split('T')[0]
      }

      // Setear los datos del task
      setSelectedTask({
        id_Crm: taskData.id_Crm || '',
        id_Usuario: taskData.id_Usuario || '',
        id_Contacto: taskData.id_Contacto || '',
        id_TipoFase: taskData.id_TipoFase || '',
        id_TipoAsunto: taskData.id_TipoAsunto || '',
        asunto: taskData.asunto || '',
        fecha: formatDateForInput(taskData.fecha) || '',
        descripcion: taskData.descripcion || '',
        isVerCaledario: taskData.isVerCaledario || false,
        id_Evento: taskData.id_Evento || '',
        id_NegocioUnidades: taskData.id_NegocioUnidades || [],
        hospitales: taskData.hospitales || '',
        especialidades: taskData.especialidades || '',
      })

      // Abrir el modal
      setTaskModalIsOpen(true)
    } catch (error) {
      console.error('Error loading task:', error)
      swalAlertError(error.message || 'Error al cargar el Lead')
    } finally {
      setIsLoadingTask(false)
    }
  }

  const closeTaskModal = () => {
    setTaskModalIsOpen(false)
    setSelectedTask({
      id_Crm: '',
      id_Usuario: '',
      id_Contacto: '',
      id_TipoFase: '',
      id_TipoAsunto: '',
      asunto: '',
      fecha: '',
      descripcion: '',
      isVerCaledario: false,
      id_Evento: '',
      id_NegocioUnidades: [],
      hospitales: '',
      especialidades: '',
    })
  }

  const sortedItems = _.orderBy(items, ['isActive', 'nombre'], ['desc', 'asc'])
  // console.log('sortedItems', sortedItems)
  return (
    <Fragment>
      <table>
        <thead>
          <tr>
            <th>
              Título presentación
            </th>
            <th className='table-th-date'>
              F.Creación
            </th>
            <th>
              Contacto
            </th>
            <th>
              Hospital / Centro y Especialidad
            </th>
            <th className="table-th-status">
              Estado
            </th>
            <th className="table-th-status">
              Lead
            </th>
            <th className='table-th-actions' style={{ width: '220px', minWidth: '220px'}}>
                Acciones
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedItems.length > 0 ? (
            sortedItems.map((presentation, index) => {
              return (
                <tr key={`${index}+${presentation.id_Presentacion}`}>
                  <td className='table-td-header'>
                      {presentation.nombre}{' '}
                  </td>
                  <td className="table-td-date">
                    {dateToDayMonthYear(presentation.fechaCreacion)}
                  </td>
                  {presentation.presentacionContacts.length > 0
                    ? presentation.presentacionContacts.map((contacto, i) => (
                        <>
                          <td
                            key={`${index}+${contacto.id_ContactoPresentation}+1`}
                          >
                            {contacto.contactosHospitales !== null
                              ? contacto.nombreContacto
                              : null}
                          </td>
                          <td
                            style={{ fontSize: '90%'}}
                            key={`${index}+${contacto.id_ContactoPresentation}+2`}
                          >
                              {contacto.contactosHospitales !== null
                                ? contacto.nombreHospital
                                : null}
                              <br />
                              {contacto.contactosHospitales !== null
                                ? contacto.tipoEspecialidades
                                : null}
                          </td>
                          <td
                            className="table-td-status"
                            align="center"
                            key={`${index}+${contacto.id_ContactoPresentation}+3`}
                          >
                            {presentationStatus(presentation.id_Status)}
                          </td>
                        </>
                      ))
                    : null}
                  <td className="table-td-status" align="center">
                    {presentation.id_CRM ? (
                      <button
                        onClick={() => toViewLeads(presentation.id_CRM)}
                        disabled={isLoadingTask}
                        title='Ver leads'
                        className='action-button'
                        style={{
                          opacity: isLoadingTask ? 0.6 : 1,
                          cursor: isLoadingTask ? 'wait' : 'pointer',
                        }}
                      >
                        <OpenBtn fill='#ED8B00' />
                        {/* {isLoadingTask && ' Cargando...'} */}
                      </button>
                    ) : (
                      <p className='products__text-readOnly' style={{ fontSize: '80%'}}>
                        No hay lead asignado
                      </p>
                    )}
                  </td>
                  <td className="table-td-actions">
                    {presentation.presentacionContacts.length > 0
                      ? presentation.presentacionContacts.map((elem, i) => (
                          <>
                            {/* Se incluye el filtro de RespuestaLgpd = 1 para poder enviar */}
                            {canEditDeleteSendPresentation(presentation) &&
                              elem.isActive && presentation.presentacionContacts[0].id_RespuestaLgpd === 1 ? (
                                <button
                                  key={`${i}+${elem.id_Presentacion}`}
                                  disabled={isDisabled}
                                  onClick={() =>
                                    handleSendPresentationToContact(
                                      elem.id_ContactoPresentation,
                                    )
                                  }
                                >
                                  <SendBtn />
                                </button>
                            ) : null}

                            {canEditDeleteSendPresentation(presentation) &&
                              elem.isActive && presentation.presentacionContacts[0].id_RespuestaLgpd === 2 ? (
                                <div style={{ display: 'inline-block', fontSize: '80%', color: 'red', textAlign: 'center' }}>
                                    No<br />
                                    Lgpd
                                </div>
                            ) : null}


                            <Link
                              style={{ marginRight: '1rem', marginLeft: '1rem'}}
                              to={
                                routes.PRESENTATION_VIEW +
                                presentation.id_Presentacion
                              }
                            >
                              Ver más
                            </Link>


                            {canEditDeleteSendPresentation(presentation) ? (
                                <button
                                  onClick={() =>
                                    gotoEdit(presentation.id_Presentacion)
                                  }
                                >
                                  <EditBtn />
                                </button>
                            ) : null}
                            {canEditDeleteSendPresentation(presentation) ? (
                                <button
                                  disabled={isDisabled}
                                  onClick={() =>
                                    handleRemovePresentation(
                                      presentation.id_Presentacion,
                                    )
                                  }
                                >
                                  <DeleteBtn />
                                </button>
                            ) : null}
                          </>
                        ))
                      : null}
                  </td>
                </tr>
              )
            })
          ) : (
            <tr>
              <td colSpan="7">
                <NullMssg mssg={mssgs.NADA_QUE_MOSTRAR_AÑADIR_PRESENTACION} />
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Modal para ver el lead/task en modo solo lectura */}
      <TasksModal
        modalIsOpen={taskModalIsOpen}
        closeModal={closeTaskModal}
        inputs={selectedTask}
        handleChange={() => {}} // No hacer nada en modo solo lectura
        handleSubmit={() => {}} // No hacer nada en modo solo lectura
        validateForm={true} // Siempre válido en modo solo lectura
        textBtn='' // Sin botón de acción
        phases={phases}
        contacts={contacts}
        events={events}
        businessunits={businessunits}
        hospitals={hospitals}
        specialties={specialties}
        isEdit={false}
        isViewMode={true} // Modo de solo lectura
        disableEventField={false}
      />
    </Fragment>
  )
}

export default PresentationListTable
